import { css } from '@emotion/react'
import { Flow, Heading, Text, Theme, useTheme } from 'bold-ui'
import { ReactComponent as AvisoCidadaoCdsIcon } from 'images/cidadao/aviso-cidadao-cds.svg'

export function CardNovidadesInativacaoLoteImoveis() {
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Flow direction='horizontal' gap={1} alignItems='center' style={styles.container}>
      <AvisoCidadaoCdsIcon css={styles.img} />
      <Flow direction='vertical' gap={0.5} style={styles.text}>
        <Heading level={3} style={styles.title}>
          Nova funcionalidade no e-SUS APS!
        </Heading>
        <Text>
          Essa funcionalidade permite inativar vários imóveis de uma vez só, higienizando o Acompanhamento do Território
          e os Relatórios Consolidados. Ao inativar um imóvel será gerada uma ficha de atualização para o mesmo. Fichas
          geradas por essa funcionalidade não são contabilizadas nos relatórios de produção. Caso você seja um Agente
          Comunitário de Saúde, evite inativar imóveis que não são da sua microárea.
        </Text>
      </Flow>
    </Flow>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    padding: 0.75rem 1.5rem;
    outline: 1px solid ${theme.pallete.gray.c60};
    background-color: ${theme.pallete.surface.main};
    border-radius: 0.4rem;
    min-height: 150px;
  `,
  text: css`
    flex: 1;
  `,
  title: css`
    color: ${theme.pallete.primary.c10};
  `,
  img: css`
    align-self: flex-end;
    margin-bottom: -0.75rem;
  `,
})
